export const DEFAULT_DETECTOR_QUERY_EXAMPLE = "Is the person giving a thumbs up?";
